export default [
  { id: 'CEO', label: 'CEO' },
  { id: 'Diretora(o/e)', label: 'Diretora(o/e)' },
  { id: 'Gerente', label: 'Gerente' },
  { id: 'Coordenadora(o/e)', label: 'Coordenadora(o/e)' },
  { id: 'Analista', label: 'Analista' },
  { id: 'Contadora(o/e)', label: 'Contadora(o/e)' },
  { id: 'Estagiária(o/e)', label: 'Estagiária(o/e)' },
  { id: 'Estudante', label: 'Estudante' },
  { id: 'Outros', label: 'Outros' }
]
